/**
 * A környezeti változók EGYETLEN belépési pontja.
 *
 * A házirend szerint közvetlen `import.meta.env` sehol máshol nem szerepel —
 * mert az a hiányzó változót csendben `undefined`-ként adja tovább, és a hiba
 * valahol mélyen, egy értelmezhetetlen hálózati kérésnél jön elő. Itt viszont
 * DOB, az indulásnál.
 */

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(
      `Hiányzó környezeti változó: ${name}. ` +
        'A Vite build-időben helyettesíti be — ellenőrizd a .env fájlt és a ' +
        'CI build-argumentumait.'
    );
  }
  return value;
}

function optional(value: string | undefined, fallback: string): string {
  return value && value.length > 0 ? value : fallback;
}

export const env = {
  /**
   * A backend alapcíme. Alapértelmezés `/api`, mert éles környezetben az nginx
   * proxyzza — a build-argumentum csak akkor kell, ha másik originre megy.
   */
  // Read at runtime from /config.js first: one image serves every environment.
  apiUrl: optional(
    (window as unknown as { __APP_CONFIG__?: Record<string, string> }).__APP_CONFIG__
      ?.VITE_API_URL || (import.meta.env.VITE_API_URL as string | undefined),
    '/api'
  ),
} as const;

export { required };
